// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.ResidentProfile.StartTransferModal.title',
    defaultMessage: 'Transfer Details',
  },
  transferReasonLabel: {
    id: 'app.containers.ResidentProfile.StartTransferModal.transferReasonLabel',
    defaultMessage: 'Reason for Transfer',
  },
  transferDateLabel: {
    id: 'app.containers.ResidentProfile.StartTransferModal.transferDateLabel',
    defaultMessage: 'Transfer Date',
  },
  transferDateTooltip: {
    id: 'app.containers.ResidentProfile.StartTransferModal.transferDateTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'The transfer date is the move-out date from the current unit. Dates when another household occupies this unit are unavailable.',
  },
  infoNote: {
    id: 'app.containers.ResidentProfile.StartTransferModal.infoNote',
    defaultMessage:
      // eslint-disable-next-line max-len
      'After you confirm the transfer and assign a unit, the transfer lease, applicable transfer certifications, and Notice to Vacate for the current unit will be created automatically using the transfer date.',
  },
  // ENG-31072: conventional households have no affordable programs on their current unit, so the
  // transfer never creates certifications and the note must not mention them.
  infoNoteConventional: {
    id: 'app.containers.ResidentProfile.StartTransferModal.infoNoteConventional',
    defaultMessage:
      // eslint-disable-next-line max-len
      'After you confirm the transfer and assign a unit, the transfer lease and Notice to Vacate for the current unit will be created automatically using the transfer date.',
  },
  cancel: {
    id: 'app.containers.ResidentProfile.StartTransferModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'app.containers.ResidentProfile.StartTransferModal.confirm',
    defaultMessage: 'Confirm',
  },
  transferReasonRequired: {
    id: 'app.containers.ResidentProfile.StartTransferModal.transferReasonRequired',
    defaultMessage: 'Reason for Transfer is required.',
  },
  // Edit mode only: explains the greyed-out days on hover of the label's info icon, and states the
  // rule behind them. Replaces the generic transferDateTooltip above, whose second sentence
  // describes ENG-30129's deferred current-unit rule and is wrong about which unit is checked.
  transferDateOccupiedHint: {
    id: 'app.containers.ResidentProfile.StartTransferModal.transferDateOccupiedHint',
    defaultMessage:
      'Dates when the current household is still occupying the unit are ' +
      "unavailable. The transfer date must be after the current household's " +
      'move-out date to prevent overlapping occupancy.',
  },
  // Shown only while the current value actually falls inside the prior occupancy — reachable by
  // typing a date, or by opening a transfer whose date predates this rule.
  transferDateOccupiedError: {
    id: 'app.containers.ResidentProfile.StartTransferModal.transferDateOccupiedError',
    defaultMessage:
      'The selected unit is occupied on the entered transfer date. Select a later transfer date.',
  },
  transferDateRequired: {
    id: 'app.containers.ResidentProfile.StartTransferModal.transferDateRequired',
    defaultMessage: 'Transfer Date is required.',
  },
  errorCreatingDraft: {
    id: 'app.containers.ResidentProfile.StartTransferModal.errorCreatingDraft',
    defaultMessage: 'Failed to start transfer. Please try again.',
  },
  dateChangeWarningHeader: {
    id: 'app.containers.ResidentProfile.StartTransferModal.dateChangeWarningHeader',
    defaultMessage: 'Changing the Transfer Date will',
  },
  dateChangeWarningBullet1: {
    id: 'app.containers.ResidentProfile.StartTransferModal.dateChangeWarningBullet1',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Cancel any previously generated transfer lease and require a new lease to be generated',
  },
  dateChangeWarningBullet2: {
    id: 'app.containers.ResidentProfile.StartTransferModal.dateChangeWarningBullet2',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Reopen and/or return any applicable transfer certifications to Pending and require compliance review again',
  },
});
